import type { BrowserOptions } from "@similarweb/sentry-logger";
import Sentry from "@similarweb/sentry-logger";

import { getUiBranch, getUiVersion } from "app/components/ProUIVersionIndication/ProUIVersionIndication";

import createIntegrationConfig from "./config/integration-config";
import createProductionConfig from "./config/production-config";

declare const window: Window & { assetsRoot: string };

const BUILD_ID_REG_EXP = /[\d]+\.[\d]+\.[\w]+/;
const SENTRY_PRODUCTION_HOST = ["pro.similarweb.com"];
// We don't want to init sentry for local development, but for any other sandbox or production environment
const SENTRY_ALLOWED_HOSTS_REG_EXP =
    /^(?!local-pro)[a-zA-Z0-9-]*-pro\.sandbox\.similarweb\.com$|^pro\.similarweb\.com$/;

export default function initSentry() {
    const {
        assetsRoot,
        location: { hostname },
    } = window;

    const isUsingUIVersion = Boolean(getUiVersion()) || Boolean(getUiBranch());
    const isProduction = SENTRY_PRODUCTION_HOST.includes(hostname);
    // We would like to init sentry only for production and sandbox environments, including ui-version only in sandbox
    const shouldInitSentry = SENTRY_ALLOWED_HOSTS_REG_EXP.test(hostname) && (!isUsingUIVersion || !isProduction);

    if (shouldInitSentry && !Sentry.isInitialized()) {
        try {
            const [buildId] = assetsRoot.match(BUILD_ID_REG_EXP);
            let config: BrowserOptions;
            if (isProduction) {
                config = createProductionConfig(buildId);
            } else {
                config = createIntegrationConfig(buildId);
            }

            if (typeof config !== "undefined") {
                Sentry.init(config);
            }
        } catch (e) {
            console.error(`Failed to init Sentry:`, e);
        }
    }
}
